import React from 'react';
import SectionLayout from '../components/SectionLayout/SectionLayout';
import AboutMain from './About/AboutMain';
import AboutSkills from './About/AboutSkills';

const About = ({ lang = 'es', aboutSection, personalInfo, skills }) => {
  const { title, description } = aboutSection;

  return (
    <SectionLayout id="about" title={title} description={description}>
      <div className="about__content">
        <AboutMain lang={lang} personalInfo={personalInfo} />
        <AboutSkills skills={skills} />
      </div>
    </SectionLayout>
  );
};

export default About;